export const API_URL = 'https://svedala-scout-anmalan.devkal.workers.dev';

export const fetchCamps = async () => {
  try {
    const response = await fetch(`${API_URL}?action=camps`);
    if (!response.ok) throw new Error('Network response was not ok');
    return await response.json();
  } catch (error) {
    console.error("Failed to fetch camps:", error);
    return [];
  }
};


export const fetchFormStructure = async (formId) => {
  try {
    const response = await fetch(`${API_URL}?action=getForm&formId=${formId}`);
    if (!response.ok) throw new Error('Network response was not ok');

    const data = await response.json();

    console.log("RAW DATA FRÅN SERVER:", data);

    if (data.error) {
      console.error("Script error:", data.error);
      return null;
    }

    if (!data.fields) {
      console.error("DATA SAKNAR FIELDS:", data);
      return null;
    }


    return {
      title: data.title,
      fields: data.fields.map((f) => ({
        id: f.id,
        type: f.type,
        title: f.title,
        label: f.title,
        required: f.required || false,
        options: f.options || [],
        helpText: f.helpText || f.description || ''
      }))
    };
  } catch (error) {
    console.error("Failed to fetch form:", error);
    return null;
  }
};

export const submitRegistration = async (campId, answers) => {
  try {
    const response = await fetch(`${API_URL}?campId=${campId}`, {
      method: 'POST',
      body: JSON.stringify(answers),
      headers: { "Content-Type": "application/json" },
    });

    const text = await response.text();

    console.log("Serverns svar:", text);

    if (text.trim().startsWith('{')) {
      const data = JSON.parse(text);
      return data.status === 'success';
    } else {
      console.error("Servern skickade inte JSON. Svar:", text);
      return false;
    }
  } catch (error) {
    console.error("Nätverksfel:", error);
    return false;
  }
};


export const fetchSwishQR = async (swishNumber, amount, message) => {
  try {
    const url = `${API_URL}?` + new URLSearchParams({
      action: 'qr',
      payee: swishNumber,
      amount: String(amount),
      message: message,
      size: '300'
    });

    const res = await fetch(url);
    const data = await res.json();

    if (data.qr) {
      return data.qr; // "data:image/png;base64,..."
    }
    console.warn('QR response saknade .qr fält:', data);
    return null;
  } catch (e) {
    console.warn('Swish QR fetch misslyckades:', e);
    return null;
  }
};